<template>
    <div>
        <h4 class="mb-2">Allowable Refunds</h4>
        <p>A refund will be issued for any of the following reasons:</p>
        <ul class="ps-4">
            <li>You are unable to attend due to a medical emergency or illness</li>
            <li>Severe weather prohibits safe travel</li>
            <li>You have notified the ECOESC a minimum of seven days prior to the start of an event</li>
        </ul>
        <h4 class="mb-2 mt-4">Non-refundable</h4>
        <ul class="ps-4">
            <li>The registrant does not show up to the event</li>
            <li>The registrant unenrolls within seven days of the start of an event</li>
            <li>The registrant performance does not meet the requirements or expectations set forth by the the event instructor/director</li>
            <li>The registrant fails to comply with the attendance requirements mandated by the event instructor/director</li>
        </ul>
        <h4 class="mb-2 mt-4">Refund Procedure</h4>
        <ul class="ps-4">
            <li>If you paid by <b>cash</b>, <b>money order</b>, or <b>personal check</b>, you will be mailed a refund check within 30 days from the date of cancellation.</li>
            <li>If you paid by <b>credit card</b>, your card will be automatically refunded within three business daysfrom the date of cancellation</li>
            <li>If you registered using a <b>purchase order</b> or <b>agency agreement code</b>, you will not be billedfor this transaction. If payment has already been submitted, a refund will be issued to the appropriate organization</li>
        </ul>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
ul>li {
    list-style-type: disc;
}
</style>